import { Box, Typography } from '@mui/material'
import theme from '../../../theme/theme'
import { useTranslation } from 'react-i18next'
import { IDefaultEntityData } from '../interfaces'
import DefaultEntitySelect from './DefaultEntitySelect'

interface LocationPreferencesProps {
    orgId: string
    defaultShipper: IDefaultEntityData | null
    defaultReceiver: IDefaultEntityData | null
    disabled: boolean
    handleLocationPreferenceChange: (
        field: 'defaultShipper' | 'defaultReceiver',
        value: IDefaultEntityData | null,
    ) => void
}

const LocationPreferences = ({
    orgId,
    defaultShipper,
    defaultReceiver,
    disabled,
    handleLocationPreferenceChange,
}: LocationPreferencesProps): JSX.Element => {
    const { t } = useTranslation()

    const onChangeDefaultShipper = (
        id: string,
        value: IDefaultEntityData | null,
    ) => {
        handleLocationPreferenceChange('defaultShipper', value)
    }

    const onChangeDefaultReceiver = (
        id: string,
        value: IDefaultEntityData | null,
    ) => {
        handleLocationPreferenceChange('defaultReceiver', value)
    }

    return (
        <Box>
            <Typography
                variant="h6"
                component="h2"
                sx={{
                    fontSize: theme.typography.h6,
                    textWrap: 'nowrap',
                    marginBottom: '15px',
                }}
            >
                {t('locationPreferences')}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                    alignItems: 'flex-start',
                }}
            >
                <DefaultEntitySelect
                    orgId={orgId}
                    value={defaultShipper}
                    onChange={onChangeDefaultShipper}
                    label="defaultShipper"
                    entityTemplateName="Shipper"
                    disabled={disabled}
                />
                <DefaultEntitySelect
                    orgId={orgId}
                    value={defaultReceiver}
                    onChange={onChangeDefaultReceiver}
                    label="defaultReceiver"
                    entityTemplateName="Receiver"
                    disabled={disabled}
                />
            </Box>
        </Box>
    )
}

export default LocationPreferences
